<template>

<header class="site-header" v-if="!Edicao">
  <div class="logo">
    <img src="@/assets/logoHeader.png" v-if="nomeEmpresa == 'BRITECH'" style="filter: invert(60%);"/>
    <img src="@/assets/dnways.png" v-if="nomeEmpresa == 'Vortex'" style="width: 100%; height: 100%;"/>
    <img src="@/assets/logoActual_v2.png" v-if="nomeEmpresa == 'ACTUAL'" style="width: 90%; height: 90%;"/>
    <img src="@/assets/logogenial.png" v-if="nomeEmpresa == 'GENIAL'" style="width: 100%; height: 100%;"/>
    <img src="@/assets/logoHeader_rji.png" v-if="nomeEmpresa == 'RJI'" />
    <img src="@/assets/logoLastro.jpg" v-if="nomeEmpresa == 'Lastro'" style="width: 100%; height: 100%;" />

  </div>
  <nav class="navigation">
    <ul>
            <li><button type="button" v-if="configuracaoToken != 'S'" class="button button-light" @click="alterarSenha()" style="cursor: pointer;">Alterar senha</button></li>
      <li><button type="button" @click="logoff" style="cursor: pointer;" class="submit-button">Logoff</button></li>
    </ul>
  </nav>
</header>

  <div class="container" :class="{containerRJI: nomeEmpresa == 'RJI' }">

        

        <div class="header">
           <h2 v-if="!Edicao">Cadastro</h2>

        <div class="info__headers" v-if="!Edicao">
            <div class="info__resumo">
                <div class="navegacao">
                    <a
                        href="javascript:;"
                        class="link"
                        :class="{ active: tab == 0, preenchido: tab > 0 }"
                        @click="selectTab(0)">
                        Informações
                    </a>

                    
                    <a
                        href="javascript:;"
                        class="link"
                        :class="{ active: tab == 1, preenchido: tab > 1 }"
                        @click="selectTab(1)"
                    >
                        Procurador
                    </a>

                    <a
                        href="javascript:;"
                        class="link"
                        :class="{ active: tab == 2, preenchido: tab > 2 }"
                        @click="selectTab(2)"
                    >
                        Dados Financeiros
                    </a>

                    <a
                        href="javascript:;"
                        class="link"
                        :class="{ active: tab == 3, preenchido: tab > 3  }"
                        @click="selectTab(3)"
                    >
                        Dados Bancários
                    </a>

                     <a
                        href="javascript:;"
                        class="link"
                        :class="{ active: tab == 4, preenchido: tab > 4 }"
                        @click="selectTab(4)"
                    >
                        Endereço
                    </a>

                     <a
                        href="javascript:;"
                        class="link"
                        :class="{ active: tab == 5, preenchido: tab > 5 }"
                        @click="selectTab(5)"
                    >
                        Upload de Documentos
                    </a>

                     <a
                        href="javascript:;"
                        class="link"
                        :class="{ active: tab == 6, preenchido: tab > 6 }"
                        @click="selectTab(6)"
                    >
                        Declarações
                    </a>

                                         <a
                        href="javascript:;"
                        class="link"
                        :class="{ active: tab == 7 }"
                        @click="selectTab(7)"
                    >
                        Produtos
                    </a>

                    

                </div>
            </div>
        </div>

        <div v-if="tab == 0" class="headerAtivo">
            <Informacoes v-if="informacoesBasicas" :Edicao="Edicao" />
                      <div v-if="!informacoesBasicas" class="loading-overlay">
            <div class="spinner"></div>
          </div>
        </div>

        <div v-if="tab == 1" class="headerAtivo">
            <Representantes :Edicao="Edicao" />
        </div>

        <div v-if="tab == 2" class="headerAtivo">
            <DadosFinanceiros v-if="informacoesFinanceiras" :informacoesFinanceiras="informacoesFinanceiras" :Edicao="Edicao"  />
                                  <div v-if="!informacoesFinanceiras" class="loading-overlay">
            <div class="spinner"></div>
          </div>
        </div>

        <div v-if="tab == 3 && informacoesBancarias" class="headerAtivo">
            <DadosBancarios v-if="informacoesBancarias"  :Edicao="Edicao"  />

                                  <div v-if="!informacoesBancarias" class="loading-overlay">
            <div class="spinner"></div>
          </div>

        </div>

        <div v-if="tab == 4" class="headerAtivo">
            <Endereco v-if="informacoesBasicas"  :informacoesBasicas="informacoesBasicas" :Edicao="Edicao" />


                                  <div v-if="!informacoesBasicas" class="loading-overlay">
            <div class="spinner"></div>
          </div>

        </div>

          <div v-if="tab == 5" class="headerAtivo">
            <UploadDocumentos :Edicao="Edicao"  />
        </div>

        
          <div v-if="tab == 6" class="headerAtivo">
            <Declaracoes  v-if="informacoesDeclaracoes" :informacoesDeclaracoes="informacoesDeclaracoes" :Edicao="Edicao"  />


                                  <div v-if="!informacoesDeclaracoes" class="loading-overlay">
            <div class="spinner"></div>
          </div>

        </div>

          <div v-if="tab == 7" class="headerAtivo">
            <Produtos :Edicao="Edicao"  />
        </div>

   
    </div>
      <ModalAlterarSenha />
  </div>

</template>


<script>

import { mapGetters } from 'vuex';
import Informacoes from './Informacoes.vue';
import DadosFinanceiros from './DadosFinanceiros.vue';
import DadosBancarios from './DadosBancarios.vue';
import Endereco from './Endereco.vue';
import Representantes from './Representantes.vue';
import UploadDocumentos from './UploadDocumentos.vue';
import Declaracoes from './Declaracoes.vue';
import Produtos from './Produtos.vue';
import api from '@/api/axios';
import Cookies from 'js-cookie';
import ModalAlterarSenha from '../AlterarSenha/ModalAlterarSenha.vue'



export default {
    components: {
      Informacoes,
      DadosFinanceiros,
      DadosBancarios,
      Endereco,
      UploadDocumentos,
      Declaracoes,
      Produtos,
      Representantes,
      ModalAlterarSenha
    },
    props: ['Edicao'],
    name: 'CadastroPF_Passo_1',
      computed: {
        ...mapGetters({
            user: 'auth/user',
            etapaCadastro: 'GET_ETAPA_CADASTRO',
            infoBasicas: 'GET_PF_INFO_BASICAS',
            infoFinanceiras: 'GET_PF_INFO_FINANCEIRAS',
            infoBancarios: 'GET_PF_INFO_BANCARIOS',
            infoDeclaracoes: 'GET_PF_INFO_DECLARACOES',
            salvarInformacoesPF: 'GET_PF_SALVAR_INFO',
            salvarObjInfoBasicas: 'GET_PF_SALVAR_INFO_BASICAS',
            salvarObjInfoFinanceira: 'GET_PF_SALVAR_INFO_FINANCEIRAS',
            salvarObjInfoBancarias: 'GET_PF_SALVAR_INFO_BANCARIAS',
            salvarObjInfoEndereco: 'GET_PF_SALVAR_INFO_ENDERECO',
            salvarObjInfoDeclaracoes: 'GET_PF_SALVAR_INFO_DECLARACOES',
            salvarObjInfoContasAdicionais: 'GET_PF_SALVAR_INFO_CONTAS_ADICIONAIS',
            ObjSalvarInformacoesUploadArquivos: 'GET_SALVAR_INFO_UPLOAD',
            salvarObjInfoBasicosRepresentante: 'GET_PF_SALVAR_INFO_BASICAS_REPRESENTANTES',
            salvarObjConcluir: 'GET_FICHA_CONCLUIR',
            salvarObjDispensaQuestionario: 'GET_PF_PJ_SALVAR_INFO_DISPENSA',
            desabilitarNotificacao: 'GET_SALVAR_INFO_DES_NOTIFICACAO',
            getConfiguracoes: 'GET_CONFIGURACOES',
        }),
        salvouTodasAbas() {
          const { gravarDados } = this;
          return Object.values(gravarDados).every(value => value === 1);
        }
    },
    data() {
        return {
          configuracaoToken: 'n',
          gravarDados: {
            salvarInformacoesPF: 0,
            salvarInformacoesRepresentante: 0,
            salvarInformacoesFinanceiras: 0,
            salvarInformacoesBancarias: 0,
            salvarInformacoesDeclaracoes: 0,
            salvarInformacoesBancariasContasAdicionais: 0,
            salvarInformacoesUpload: 0,
            salvarInformacoesDispensaQuestionario: 0
          },
          nomeEmpresa: '',
          tab: 0,
          informacoesBasicas: null,
          informacoesFinanceiras: this.infoFinanceiras,
          informacoesBancarias: this.infoBancarios,
          informacoesDeclaracoes: this.infoDeclaracoes
        }
    },
    created() {
        this.ObterDados();
        this.$store.commit('SET_FICHA_CONCLUIR', false);
       
    },
    async mounted() {
      this.nomeEmpresa = process.env.VUE_APP_NOME_EMPRESA;
      this.$store.commit('SET_PF_SALVAR_INFO', false);
      if(!this.Edicao){
        this.$store.commit('SET_ETAPA_CADASTRO', 0)
      }else{
         this.tab = this.etapaCadastro;
      }
      await this.fetchConfiguracao(['COM TOKEN']);
      this.configuracaoToken = this.getConfiguracoes('COM TOKEN').Valor;
    },
    methods: {
      formatarValorFinanceiro(valorString) {
        // Remove 'R$ ', substitui ',' por '.' e converte para número
        const valorNumerico = parseFloat(valorString.replace('R$ ', '').replace(/\./g, '').replace(',', '.'));
        return isNaN(valorNumerico) ? 0 : valorNumerico; // Retorna 0 se não for um número
      },
      alterarSenha(){
         this.$store.commit('SET_ABRIR_ALTERAR_SENHA', true)
      },
      ObterDados(){
       this.$store.dispatch('FETCH_PF_INFO_BASICAS', this.user.ClienteId);
       this.$store.dispatch('FETCH_PF_INFO_BASICAS_REPRESENTANTES', this.user.ClienteId);
       
       this.$store.dispatch('FETCH_PF_INFO_FINANCEIRAS', this.user.ClienteId);
       this.$store.dispatch('FETCH_PF_INFO_BANCARIOS', this.user.ClienteId);
       this.$store.dispatch('FETCH_PF_INFO_DECLARACOES', this.user.ClienteId);

       this.$store.dispatch('FETCH_CONSULTA_BANCOS');

       this.$store.dispatch('FETCH_CONSULTA_NACIONALIDADES');
       
       this.$store.dispatch('FETCH_CONSULTA_OCUPACAO_PROFISSIONAL');
       this.$store.dispatch('FETCH_CONSULTA_FORMACAO_PROFISSIONAL');
       this.$store.commit('SET_PF_SALVAR_INFO', false);
       this.$store.dispatch('FETCH_QUESTIONARIO_BUSCAR_QUESTOES');

      this.$store.commit('SET_PF_SALVAR_INFO_BANCARIAS', null);
      this.$store.commit('SET_PF_SALVAR_INFO_CONTAS_ADICIONAIS', null);

      this.$store.dispatch('FETCH_CONSULTA_DISCLAIMER');
      
      this.$store.dispatch('FETCH_DISPENSA_QUESTIONARIO', this.user.ClienteId);
  
      },
      async salvarConcluir(){

                if(this.salvarInformacoesPF == true && this.salvarObjConcluir == true)
                {

                var encodedCredentials = btoa('sat@sat:sat23!');

                var objConcluir = { ClienteId: this.user.ClienteId };
                this.$store.commit('SET_PF_SALVAR_INFO', false);
                this.$store.commit('SET_FICHA_CONCLUIR', false);

                    await api.post('/PessoaFisica/ConcluirCadastro', objConcluir, {
                      headers: {
                        'Authorization': `Basic ${encodedCredentials}`
                      },
                    })
                    .then((retorno) => {
                        if(retorno.status == 200)
                        {

                          this.$swal({
                              icon: 'success',
                              title: 'Cadastro enviado para análise!',
                              text: 'Em até 48h úteis, a empresa receberá novidades no e-mail informado.',
                          }).then((result) => {
                              if (result.value) {
                                 this.logoff();
                              }
                          });

                        }
                    })
                    .catch((error) => {
                        this.$store.commit('SET_PF_SALVAR_INFO', false);
                        this.$swal({
                            icon: 'error',
                            title: 'Dados informados inválidos na aba Declarações',
                            text: `${error.response.data.data[0]}`,
                        });
                    });

                }else{
                        this.$store.commit('SET_PF_SALVAR_INFO', false);
                     if(this.desabilitarNotificacao == true){
                          this.$store.commit('SET_SALVAR_INFO_DES_NOTIFICACAO', false);
                     }else{
                      if(this.Edicao){
                        this.$swal({
                              icon: 'warning',
                              title: 'Cadastro atualizado',
                              text: 'As informações serão revisadas pela equipe responsável e você poderá acompanhar essa revisão pelo status.',
                          });
                      }else{
                        this.$swal({
                              icon: 'success',
                              title: 'Alterações realizadas com sucesso!',
                              text: 'Dados informados foram salvos com sucesso.',
                          });
                      }
                   }

                          this.ObterDados();
                }

      },
      async salvarInformacoesDeclaracoes(){


        if(this.salvarInformacoesPF)
        {
          var encodedCredentials = btoa('sat@sat:sat23!');

          if(this.salvarObjInfoDeclaracoes == null)
          {
            this.gravarDados.salvarInformacoesDeclaracoes = 1;
            return;
          }else{

                await api
                    .post('/PessoaFisica/declaracoes', this.salvarObjInfoDeclaracoes, { headers: { 'Authorization': `Basic ${encodedCredentials}`}} )
                    .then((retorno) => {
                        if(retorno.status == 200)
                        {
                          this.$store.commit('SET_PF_SALVAR_INFO_DECLARACOES', null);
                          this.gravarDados.salvarInformacoesDeclaracoes = 1;
                          return;
                        }
                    })
                    .catch((error) => {
                        this.gravarDados.salvarInformacoesDeclaracoes = 2;
                        this.$store.commit('SET_PF_SALVAR_INFO', false);
                        this.$swal({
                            icon: 'error',
                            title: 'Dados informados inválidos na aba Declarações',
                            text: `${error.response.data.data[0]}`,
                        });
                    });



          }

        }
        


                  
      },
      async salvarInformacoesDispensaQuestionario(){

        if(this.salvarInformacoesPF)
        {
          var encodedCredentials = btoa('sat@sat:sat23!');

          if(this.salvarObjDispensaQuestionario == null)
          {
            this.gravarDados.salvarInformacoesDispensaQuestionario = 1;
            return;
          }else{

                await api
                    .post('/suitability/dispensa-questionario', this.salvarObjDispensaQuestionario, { headers: { 'Authorization': `Basic ${encodedCredentials}`}} )
                    .then((retorno) => {
                        if(retorno.status == 200)
                        {
                          this.$store.commit('SET_PF_PJ_SALVAR_INFO_DISPENSA', null);
                          this.$store.dispatch('FETCH_PERFIL_CLIENTE', this.user.ClienteId);
                          this.gravarDados.salvarInformacoesDispensaQuestionario = 1;
                          return;
                        }
                    })
                    .catch((error) => {
                        this.gravarDados.salvarInformacoesDispensaQuestionario = 2;
                        this.$store.commit('SET_PF_SALVAR_INFO', false);
                        this.$swal({
                            icon: 'error',
                            title: 'Dados informados inválidos na aba Produtos, sessão Dispensa de Questionário.',
                            text: `${error.response.data.data[0]}`,
                        });
                    });



          }

        }
      },
      async salvarInformacoesUpload(){

            if(!this.salvarInformacoesPF)
            {
              return;
            }

            if(this.ObjSalvarInformacoesUploadArquivos == null){
              this.$store.dispatch('FETCH_CONSULTA_LISTA_DOCUMENTOS_UPLOAD_REALIZADO', this.user.ClienteId);
              return;
            }
            
              var encodedCredentials = btoa('sat@sat:sat23!');

              if(this.ObjSalvarInformacoesUploadArquivos == null){
                  this.gravarDados.salvarInformacoesUpload = 1;
                  return;
              }else{

              const data = {
                  documentos: this.ObjSalvarInformacoesUploadArquivos
              };

                await api
                    .post('/cliente/documentos', data, { headers: { 'Authorization': `Basic ${encodedCredentials}`}} )
                    .then((retorno) => {
                        if(retorno.status == 200)
                        {
                          this.$store.commit('SET_SALVAR_INFO_UPLOAD', null);
                          this.gravarDados.salvarInformacoesUpload = 1;
                          this.$store.dispatch('FETCH_CONSULTA_LISTA_DOCUMENTOS_UPLOAD_REALIZADO', this.user.ClienteId);
                              return;
                        }
                    })
                    .catch((error) => {
                      this.gravarDados.salvarInformacoesUpload = 2;
                        this.$store.commit('SET_PF_SALVAR_INFO', false);
                        this.$swal({
                            icon: 'error',
                            title: 'Falha ao realizar upload de documentos',
                            text: `${error.response.data.data[0]}`,
                        });
                    })
                    .finally(() => {
                      this.$store.dispatch('FETCH_CONSULTA_LISTA_DOCUMENTOS_UPLOAD_REALIZADO', this.user.ClienteId);
                    });



              }

      },
      async salvarInformacoesBancariasContasAdicionais(){


        if(this.salvarInformacoesPF)
        {
          var encodedCredentials = btoa('sat@sat:sat23!');

          if(this.salvarObjInfoContasAdicionais == null)
          {
            this.gravarDados.salvarInformacoesBancariasContasAdicionais = 1;
            return;
          }else{

          let todasChamadasBemSucedidas = true;

          
          var dadosBancariosObj = this.salvarObjInfoContasAdicionais.filter(conta => conta.Principal == false);

              for (const conta of dadosBancariosObj) {
                  try {
                      const retorno = await api.post('/PessoaFisica/dadosBancarios', conta, {
                          headers: { 'Authorization': `Basic ${encodedCredentials}` }
                      });
                      if (retorno.status != 200) {
                          this.$store.commit('SET_PF_SALVAR_INFO_CONTAS_ADICIONAIS', null);
                          this.gravarDados.salvarInformacoesBancariasContasAdicionais = 2;
                          todasChamadasBemSucedidas = false;

                          throw new Error('Falha ao salvar dados da conta bancária adicional');
                      }
                  } catch (error) {
                    const errorMessage = error.response?.data?.data?.[0] || 'Erro ao salvar os dados bancários adicionais.';
                    this.$swal({
                      icon: 'error',
                      title: 'Dados informados inválidos na aba Dados Bancários',
                      text: errorMessage,
                    });
                    this.$store.commit('SET_PF_SALVAR_INFO', false);
                    todasChamadasBemSucedidas = false;
                    break; // Sai do loop se houver um erro
                  }
              }

          if (todasChamadasBemSucedidas) {
            this.gravarDados.salvarInformacoesBancariasContasAdicionais = 1;
              return;
          }

        }
                  



        }
        

      },

      async salvarInformacoesBancarias(){


        if(this.salvarInformacoesPF)
        {
          var encodedCredentials = btoa('sat@sat:sat23!');

          if(this.salvarObjInfoBancarias == null)
          {
              this.gravarDados.salvarInformacoesBancarias = 1;
              return;
          }else{

          var dadosBancariosObj = this.salvarObjInfoContasAdicionais.filter(conta => conta.Principal == true);

                    await api
                    .post('/PessoaFisica/dadosBancarios', dadosBancariosObj, { headers: { 'Authorization': `Basic ${encodedCredentials}`}} )
                    .then((retorno) => {
                        if(retorno.status == 200)
                        {
                          this.$store.commit('SET_PF_SALVAR_INFO_BANCARIAS', null);
                          this.gravarDados.salvarInformacoesBancarias = 1;

                        }
                    })
                    .catch((error) => {
                      this.gravarDados.salvarInformacoesBancarias = 2;
                        this.$swal({
                            icon: 'error',
                            title: 'Dados informados inválidos na aba Dados Bancários',
                            text: `${error.response.data.data[0]}`,
                        });

                        this.$store.commit('SET_PF_SALVAR_INFO', false);

                    });



          }

        }
        

      },
      async salvarInformacoesRepresentante()
      {

        if(this.salvarInformacoesPF)
        {
          var encodedCredentials = btoa('sat@sat:sat23!');

          if(this.salvarObjInfoBasicosRepresentante == null)
          {
                this.gravarDados.salvarInformacoesRepresentante = 1;
                return;
          }
          else
          {

          let todasChamadasBemSucedidas = true;

              for (const conta of this.salvarObjInfoBasicosRepresentante) {
                  try {
                      const retorno = await api.post('/PessoaFisica/representante', conta, {
                          headers: { 'Authorization': `Basic ${encodedCredentials}` }
                      });
                      if (retorno.status != 200) {
                        this.gravarDados.salvarInformacoesRepresentante = 2;
                          todasChamadasBemSucedidas = false;
                          break; // Sai do loop se a resposta não for 200
                      }
                  } catch (error) {
                      this.$swal({
                          icon: 'error',
                          title: 'Dados informados inválidos na aba Dados Bancários',
                          text: `${error.response.data.data[0]}`,
                      });
                      this.$store.commit('SET_PF_SALVAR_INFO', false);
                      todasChamadasBemSucedidas = false;
                      break; // Sai do loop se houver um erro
                  }
              }

          if (todasChamadasBemSucedidas) {
            this.$store.commit('SET_PF_SALVAR_INFO_BASICAS_REPRESENTANTES', null);
            this.gravarDados.salvarInformacoesRepresentante = 1;
              return;
          }


          }
        }


      },
      async salvarInformacoesFinanceiras()
      {

        if(this.salvarInformacoesPF)
        {
          var encodedCredentials = btoa('sat@sat:sat23!');

          if(this.salvarObjInfoFinanceira == null)
          {
                this.gravarDados.salvarInformacoesFinanceiras = 1;
                return;
          }
          else
          {

          const dadosFormatados = {...this.salvarObjInfoFinanceira};

          // Formata cada campo financeiro
          dadosFormatados.RemuneracaoMensal = this.formatarValorFinanceiro(dadosFormatados.RemuneracaoMensal);
          dadosFormatados.OutrosRendimentos = this.formatarValorFinanceiro(dadosFormatados.OutrosRendimentos);
          dadosFormatados.BensImoveis = this.formatarValorFinanceiro(dadosFormatados.BensImoveis);
          dadosFormatados.BensMoveis = this.formatarValorFinanceiro(dadosFormatados.BensMoveis);
          dadosFormatados.PatrimonioLiquido = this.formatarValorFinanceiro(dadosFormatados.PatrimonioLiquido);
          dadosFormatados.PatrimonioTotal = this.formatarValorFinanceiro(dadosFormatados.PatrimonioTotal);



                await api
                    .post('/PessoaFisica/dadosFinanceiros', dadosFormatados, { headers: { 'Authorization': `Basic ${encodedCredentials}`}} )
                    .then((retorno) => {
                        if(retorno.status == 200)
                        {
                          this.$store.commit('SET_PF_SALVAR_INFO_FINANCEIRAS', null);
                          this.gravarDados.salvarInformacoesFinanceiras = 1;
                          return;

                        }
                    })
                    .catch((error) => {
                      this.gravarDados.salvarInformacoesFinanceiras = 2;
                        this.$store.commit('SET_PF_SALVAR_INFO', false);
                        this.$swal({
                            icon: 'error',
                            title: 'Dados informados inválidos na aba Informações',
                            text: `${error.response.data.data[0]}`,
                        });
                    });
          }
        }
      },
      selectTab(tabSelected){
        if(tabSelected < this.tab){
          this.tab = tabSelected;
          this.$store.commit('SET_ETAPA_CADASTRO', this.tab)
        }
    },
    logoff(){
            localStorage.removeItem('ClienteId');
            localStorage.removeItem('NomeRazaoSocial');
            localStorage.removeItem('Email');
            localStorage.removeItem('token');
            Cookies.remove('nomeUsuarioLogado'); 
            
            this.$router.push({ name: 'UserLogin' });
    },
    converterData(dataString) {
      if (dataString && dataString !== '0001-01-01T00:00:00') {
          let data = new Date(dataString);
          let ano = data.getFullYear();
          let mes = (data.getMonth() + 1).toString().padStart(2, '0'); // adiciona um 0 à esquerda se for de 1 a 9
          let dia = data.getDate().toString().padStart(2, '0');
          return `${ano}-${mes}-${dia}`; // retorna a data no formato 'YYYY-MM-DD'
        } else {
          return null;
        }
    },
    formatarDadosBasicos(dados) {
        return {
          ClienteId: dados.ClienteId,
          DataNascimento: this.converterData(dados.DataNascimento),
          Sexo: dados.Sexo || '',
          EstadoCivil: dados.EstadoCivil || '',
          Ocupacao: dados.Ocupacao || '',
          NumeroDocumento: dados.NumeroDocumento || '',
          TipoDocumento: dados.TipoDocumento || '',
          DataEmissao: this.converterData(dados.DataEmissao),
          OrgaoEmissao: dados.OrgaoEmissao || '',
          DocumentoUf: dados.DocumentoUf || '',
          Nacionalidade: dados.Nacionalidade || '',
          Naturalidade: dados.Naturalidade || '',
          Pais: dados.Pais || '',
          NomeMae: dados.NomeMae || '',
          NomePai: dados.NomePai || '',
          NomeConjugue: dados.NomeConjugue || '',
          CpfConjugue: dados.CpfConjugue || '',
          Logradouro: dados.Logradouro || '',
          LogradouroNumero: dados.LogradouroNumero || '',
          LogradouroComplemento: dados.LogradouroComplemento || '',
          Bairro: dados.Bairro || '',
          Cidade: dados.Cidade || '',
          Cep: dados.Cep || '',
          Uf: dados.Uf || '',
          LogradouroPais: dados.LogradouroPais || '',
          Telefone: dados.Telefone || '',
          Telefone2: dados.Telefone2 || '',
          Email: dados.Email || '',
          PoliticamenteExposta: dados.PoliticamenteExposta,
          PoliticamenteExpostaDescricao: dados.PoliticamenteExpostaDescricao || '',
          FormacaoProfissional: dados.FormacaoProfissional || '',
          Instituicao: dados.Instituicao || '',
          CnpjTrabalha: dados.CnpjTrabalha || '',
          EnderecoComercial: dados.EnderecoComercial || '',
          EnderecoComercialNumero: dados.EnderecoComercialNumero || '',
          EnderecoComercialComplemento: dados.EnderecoComercialComplemento || '',
          EnderecoComercialBairro: dados.EnderecoComercialBairro || '',
          EnderecoComercialCep: dados.EnderecoComercialCep || '',
          EnderecoComercialCidade: dados.EnderecoComercialCidade || '',
          EnderecoComercialEstado: dados.EnderecoComercialEstado || '',
          EnderecoComercialPais: dados.EnderecoComercialPais || '',
          TelefoneComercial: dados.TelefoneComercial || '',
          EmailComercial: dados.EmailComercial || '',
          EnderecoCorrespondencia: dados.EnderecoCorrespondencia || '',
          LogradouroOutro: dados.LogradouroOutro || '',
          LogradouroNumeroOutro: dados.LogradouroNumeroOutro || '',
          LogradouroComplementoOutro: dados.LogradouroComplementoOutro || '',
          BairroOutro: dados.BairroOutro || '',
          CidadeOutro: dados.CidadeOutro || '',
          UfOutro: dados.UfOutro || '',
          CepOutro: dados.CepOutro || '',
          PaisOutro: dados.PaisOutro || '',
          ClienteIncapaz: dados.ClienteIncapaz,
          ClienteEmancipado: dados.ClienteEmancipado,

          NomeRepresentante: dados.NomeRepresentante || '',
          GrauRelacionamento: dados.GrauRelacionamento || '',
          EmissorOrdem: dados.EmissorOrdem,
          DocumentoRepresentante: dados.DocumentoRepresentante || '',
          CpfRepresentante: dados.CpfRepresentante || '',
          PepRepresentante: dados.PepRepresentante,

          NomeRepresentante2: dados.NomeRepresentante2 || '',
          GrauRelacionamento2: dados.GrauRelacionamento2 || '',
          EmissorOrdem2: dados.EmissorOrdem2,
          DocumentoRepresentante2: dados.DocumentoRepresentante2 || '',
          CpfRepresentante2: dados.CpfRepresentante2 || '',
          PepRepresentante2: dados.PepRepresentante2,

          // Outras propriedades conforme necessário
        };
    },
    }, 
    watch: {
      salvouTodasAbas(newVal) {
        if (newVal) {
          this.salvarConcluir();
          this.gravarDados.salvarInformacoesPF = 0;
          this.gravarDados.salvarInformacoesRepresentante = 0;
          this.gravarDados.salvarInformacoesFinanceiras = 0;
          this.gravarDados.salvarInformacoesBancarias = 0;
          this.gravarDados.salvarInformacoesDeclaracoes = 0;
          this.gravarDados.salvarInformacoesBancariasContasAdicionais = 0;
          this.gravarDados.salvarInformacoesUpload = 0;
          this.gravarDados.salvarInformacoesDispensaQuestionario = 0;
        }
      },
      etapaCadastro(){
        // this.$emit('update:informacoesBasicas', this.infoBasicas);
        this.tab = this.etapaCadastro;
      },
      infoBasicas(){
        this.informacoesBasicas = this.infoBasicas;
        this.informacoesBasicas.Nome = this.user.NomeRazaoSocial;
      },
      infoFinanceiras(){
        this.informacoesFinanceiras = this.infoFinanceiras;
      },
      infoBancarios(){
        this.informacoesBancarias = this.infoBancarios;
      },
      infoDeclaracoes(){
        this.informacoesDeclaracoes = this.infoDeclaracoes;
      },
      async salvarInformacoesPF(){
        if(this.salvarInformacoesPF)
        {

          this.salvarInformacoesRepresentante();
          this.salvarInformacoesFinanceiras();
          this.salvarInformacoesBancarias();
          this.salvarInformacoesDeclaracoes();
          this.salvarInformacoesBancariasContasAdicionais();
          this.salvarInformacoesUpload();
          this.salvarInformacoesDispensaQuestionario();

          var encodedCredentials = btoa('sat@sat:sat23!');

                if(this.salvarObjInfoBasicas == null && this.salvarObjInfoEndereco == null)
                {
                  this.gravarDados.salvarInformacoesPF = 1;
                  return;
                }else{
                  var objInfoBasicas = null;

                  if(this.salvarObjInfoBasicas == null)
                  {
                    objInfoBasicas = this.formatarDadosBasicos(this.informacoesBasicas);
                  }else{
                    objInfoBasicas = this.salvarObjInfoBasicas;
                  }

                  if(this.salvarObjInfoEndereco != null)
                  {
                      objInfoBasicas.Cep = this.salvarObjInfoEndereco.Cep;
                      objInfoBasicas.Logradouro = this.salvarObjInfoEndereco.Logradouro;
                      objInfoBasicas.LogradouroNumero = this.salvarObjInfoEndereco.LogradouroNumero;
                      objInfoBasicas.LogradouroComplemento = this.salvarObjInfoEndereco.LogradouroComplemento;
                      objInfoBasicas.Bairro = this.salvarObjInfoEndereco.Bairro;
                      objInfoBasicas.Cidade = this.salvarObjInfoEndereco.Cidade;
                      objInfoBasicas.Uf = this.salvarObjInfoEndereco.Uf;
                      objInfoBasicas.Pais = this.salvarObjInfoEndereco.Pais;
                      objInfoBasicas.EnderecoCorrespondencia = this.salvarObjInfoEndereco.EnderecoCorrespondencia;
                  

                      objInfoBasicas.CepOutro = this.salvarObjInfoEndereco.CepOutro;
                      objInfoBasicas.LogradouroOutro = this.salvarObjInfoEndereco.LogradouroOutro;
                      objInfoBasicas.LogradouroNumeroOutro = this.salvarObjInfoEndereco.LogradouroNumeroOutro;
                      objInfoBasicas.LogradouroComplementoOutro = this.salvarObjInfoEndereco.LogradouroComplementoOutro;
                      objInfoBasicas.BairroOutro = this.salvarObjInfoEndereco.BairroOutro;
                      objInfoBasicas.CidadeOutro = this.salvarObjInfoEndereco.CidadeOutro;
                      objInfoBasicas.UfOutro = this.salvarObjInfoEndereco.UfOutro;
                      objInfoBasicas.PaisOutro = this.salvarObjInfoEndereco.PaisOutro;                  


                      objInfoBasicas.EnderecoComercialCep = this.salvarObjInfoEndereco.EnderecoComercialCep;
                      objInfoBasicas.EnderecoComercial = this.salvarObjInfoEndereco.EnderecoComercial;
                      objInfoBasicas.EnderecoComercialNumero = this.salvarObjInfoEndereco.EnderecoComercialNumero;
                      objInfoBasicas.EnderecoComercialComplemento = this.salvarObjInfoEndereco.EnderecoComercialComplemento;
                      objInfoBasicas.EnderecoComercialBairro = this.salvarObjInfoEndereco.EnderecoComercialBairro;
                      objInfoBasicas.EnderecoComercialCidade = this.salvarObjInfoEndereco.EnderecoComercialCidade;
                      objInfoBasicas.EnderecoComercialEstado = this.salvarObjInfoEndereco.EnderecoComercialEstado;
                      objInfoBasicas.EnderecoComercialPais = this.salvarObjInfoEndereco.EnderecoComercialPais;                  
                  
                  
                  }

                await api
                    .post('/PessoaFisica/informacaoBasica', objInfoBasicas, { headers: { 'Authorization': `Basic ${encodedCredentials}`}} )
                    .then((retorno) => {
                        if(retorno.status == 200)
                        {
                          this.$store.commit('SET_PF_SALVAR_INFO_BASICAS', null);
                          this.$store.commit('SET_PF_SALVAR_INFO_ENDERECO', null);
                          this.gravarDados.salvarInformacoesPF = 1;
                          return;
                        }
                    })
                    .catch((error) => {
                        this.gravarDados.salvarInformacoesPF = 2;
                        this.$swal({
                            icon: 'error',
                            title: 'Dados informados inválidos na aba Informações',
                            text: `${error.response.data.data[0]}`,
                        });



                        this.$store.commit('SET_PF_SALVAR_INFO', false);

                    });


                }

        }

      }
      
    }
}

</script>


<style lang="scss" scoped>

@import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600&display=swap');

/* Estilos globais */
body, html {
  height: 100%;
  margin: 0;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #f5f5f5;
}

  .link__before {
        display: flex;
        align-items: center;
        justify-content: center;
        border-bottom: 1px solid;
        max-width: 70px;

    }

.site-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0rem 2rem; /* Ajuste conforme necessário */
  background-color: #fff; /* Ou qualquer cor de fundo que você deseja */
}

    
.info__resumo {
    display: flex;
    width: 100%;
    padding-bottom: 9px;
    .navegacao {
        display: flex;
        flex-wrap: wrap;

        .link {
          font-size: 14px;
            text-align: center;
            margin-right: 30px;
            margin-top: 20px;
            color: #667085;
            text-decoration: none;
            font-family: 'Inter', sans-serif;
            font-weight: 500;

            &.first {
                text-align: left;
            }

            &.preenchido {
                font-size: 12px;
                padding-left: 30px;
                font-weight: 500;
                position: relative;
                text-decoration: none;
                // box-shadow: 0 3px 0 #00064F;
                color: #12481f;
                background-image: url('@/assets/aprovado.png'); /* Atualize com o caminho correto */
                background-repeat: no-repeat;
                background-position: 10px center; 
                background-size: 20px 20px;
             }

            &.active {
                font-weight: 500;
                position: relative;
                text-decoration: none;
                // box-shadow: 0 3px 0 #00064F;
                color: #00064F;

              &::after  {
                  content: ''; /* Necessário para que o pseudo-elemento seja exibido */
                  position: absolute; /* Posiciona o pseudo-elemento em relação ao link */
                  left: 0; /* Alinha à esquerda do link */
                  bottom: -9px; /* Distância do sublinhado em relação à base do texto */
                  width: 100%; /* Largura do sublinhado igual à do elemento link */
                  height: 1px; /* Espessura do sublinhado */
                  background-color: #00064F; /* Cor do sublinhado */
              }
            }
        }
    }
}

.logo img {
  height: 32px; /* Ajuste conforme o tamanho desejado para o logo */
  width: 142px;
}

.navigation ul {
  list-style: none;
  display: flex;
  gap: 1rem; /* Espaço entre os itens de navegação */
}

.navigation li {
  padding: 0.5rem 1rem; /* Ajuste conforme necessário */
}

.navigation a {
  text-decoration: none;
  color: #000; /* Cor do texto */
}

.navigation a.router-link-active {
  color: #00235C; /* Cor quando o link está ativo */
}

/* Estilização específica para o botão de cadastro */
.navigation a.router-link-exact-active {
  background-color: #00235C; /* Cor de fundo para o botão de cadastro */
  color: #fff;
  border-radius: 5px; /* Raio da borda para fazer os cantos arredondados */
  padding: 0.5rem 1rem;
}


/* Estilos para o container do login */
.container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 40px;
  padding-top: 0px;
  border-radius: 10px;
  background-color: white;
//   box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  width: 80%;
    margin-left: 10%;
}

.logomark{
    width: 54px;
    height: 43.2px;
}


.info__headers{
  display: flex;
  justify-content: flex-end;
  align-items: center;
  flex-direction: column;
  width: 100%;
  border-bottom: 1px solid #EAECF0;
}


.header {
  width: 100%;
  justify-content: flex-start;
}

.header h2 {
  width: 360px; /* Largura do elemento */
  height: 38px; /* Altura do elemento */
  font-family: 'Gabarito', sans-serif; /* Família da fonte, certifique-se de que 'Gabarito' esteja importada ou substitua pelo nome correto da fonte */
  font-weight: 600; /* Peso da fonte semibold */
  font-size: 30px; /* Tamanho da fonte */
  line-height: 38px; /* Altura da linha */
  text-align: left; /* Alinhamento do texto ao centro */
  color: #101828;
  margin-bottom: 0px;

}

.header p {
  font-family: 'Inter', sans-serif; /* Família da fonte Inter */
  font-weight: 400; /* Peso normal da fonte */
  font-size: 16px; /* Tamanho da fonte */
  line-height: 24px; /* Altura da linha */
  text-align: center; /* Alinhamento do texto ao centro */
  color: #6E6E6E; /* Cor do texto em cinza (500) - este é um cinza aproximado, ajuste o código hexadecimal conforme necessário */
}

.footer p {
  font-family: 'Inter', sans-serif;
  color: #667085; /* Este é um cinza genérico, ajuste conforme necessário */
  font-size: 16px; /* Exemplo de tamanho de fonte, ajuste conforme necessário */
  line-height: 24px; /* Exemplo de altura de linha, ajuste conforme necessário */
}

.footer a {
  font-weight: 600; /* Para 'Cadastre-se', que parece ser mais destacado */
  color: #101828; /* Este é o azul padrão de links, ajuste conforme necessário */
  text-decoration: none; /* Para sublinhar o link */
}

/* Aplicando estilos de fonte */
button {
  font-family: 'Inter', sans-serif;
  font-size: 16px;
  font-weight: 600;
  line-height: 24px;
  letter-spacing: 0;
  text-align: left;
}

.entrar-button{
    color: #667085;
    background: white;
}

input {
  font-family: 'Inter', sans-serif;
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  padding: 10px;
  margin-bottom: 16px; /* Ajuste para a linha de altura */
  border: 1px solid #ccc;
  border-radius: 8px; /* Arredondamento dos inputs */
  box-sizing: border-box; /* Garante que o padding não adicione largura extra */
  width: 100%; /* Para garantir que os inputs ocupem toda a largura do container */
    
 }

.erroBorder{
        border: 1px solid #E73D3D !important;
        margin-bottom: 0px;
}
 
.erro {
    font-family: 'Inter', sans-serif;
    font-weight: 400;
    margin-top: 0px;
    color: #E73D3D;
}


/* Estilos para os rótulos (labels) do formulário */
.form .input-field label {
  font-family: 'Inter', sans-serif; /* Família da fonte Inter */
  font-weight: 500; /* Peso médio da fonte */
  font-size: 14px; /* Tamanho da fonte */
  line-height: 20px; /* Altura da linha */
  color: #344054; /* Cor do texto em cinza escuro */
}


/* Estilos para o formulário */
form {
  display: flex;
  flex-direction: column;
}

/* Estilos para os inputs */
input {
  padding: 10px;
  margin-bottom: 20px;
  border: 1px solid #ddd;
  border-radius: 4px;
}

/* Botão de entrar */
button {
  padding: 10px;
  background-color: #00235C;;
  color: white;
  border: none;
  border-radius: 4px;
  text-align: center;
}

/* Media query para telas menores */
@media (max-width: 600px) {
  .login-container {
    margin: 20px;
    padding: 10px;
  }

  input, button {
    margin-bottom: 10px;
  }
}

h2 {
  text-align: center;
  margin-bottom: 20px;
}

.forgot-password {
  font-family: 'Inter', sans-serif;
  display: block;
  text-align: center;
  margin-bottom: 20px;
  font-weight: 600;
  color: #00064F;
  text-decoration: none;
}

.signup {
  text-align: center;
  margin-top: 20px;
}

.signup a {
  color: blue;
  text-decoration: none;
}


</style>